import { html, nothing } from "lit";
import { map } from "lit/directives/map.js";
import { styleMap } from "lit/directives/style-map.js";
import { z } from "zod";
import { HexColor } from "./color";
import { nilable } from "./nilable";
import { type ParserType, parser } from "./parser";
import type { Size } from "./size";

export type TagColor = ParserType<typeof TagColor>;
export const TagColor = parser(nilable(HexColor.schema));

export type TagFormatOptions = {
  size?: Size;
};

export type Tag = ParserType<typeof Tag>;
export const Tag = Object.freeze({
  format(tag: Omit<Tag, "id">, options?: TagFormatOptions) {
    const opt = options ?? {};
    const styles = {
      color: tag.color,
      backgroundColor: tag.backgroundColor,
    };
    return html`<wa-tag style=${styleMap(styles)} size=${opt.size ?? nothing}>${tag.name}</wa-tag>`;
  },
  ...parser(
    z.strictObject({
      id: z.string(),
      name: z.string(),
      color: TagColor.schema,
      backgroundColor: TagColor.schema,
    }),
  ),
});

export type Tags = ParserType<typeof Tags>;
export const Tags = Object.freeze({
  format(tags: Tags, options?: TagFormatOptions) {
    return html`${map(tags, (t) => Tag.format(t, options))}`;
  },
  ...parser(z.array(Tag.schema)),
});
